import React, { useId } from 'react';

const Logo = ({ size = 32, className = "" }) => {
    const id = useId();
    const gradientId = `logo-gradient-${id}`;
    const shadowId = `logo-shadow-${id}`;

    return (
        <div className={`logo-wrapper ${className}`} style={{ display: 'inline-flex', alignItems: 'center', gap: '12px' }}>
            <svg
                width={size}
                height={size}
                viewBox="0 0 100 100"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="logo-svg"
            >
                <defs>
                    <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#1A7A4A" />
                        <stop offset="100%" stopColor="#15633C" />
                    </linearGradient>
                    <filter id={shadowId} x="-20%" y="-20%" width="140%" height="140%">
                        <feGaussianBlur in="SourceAlpha" stdDeviation="3" />
                        <feOffset dx="0" dy="4" result="offsetblur" />
                        <feComponentTransfer>
                            <feFuncA type="linear" slope="0.3" />
                        </feComponentTransfer>
                        <feMerge>
                            <feMergeNode />
                            <feMergeNode in="SourceGraphic" />
                        </feMerge>
                    </filter>
                </defs>

                {/* Main Card Shape */}
                <rect
                    x="10"
                    y="25"
                    width="80"
                    height="55"
                    rx="12"
                    fill={`url(#${gradientId})`}
                    filter={`url(#${shadowId})`}
                />

                {/* Decorative Lines */}
                <rect x="22" y="40" width="30" height="4" rx="2" fill="white" fillOpacity="0.4" />
                <rect x="22" y="50" width="20" height="4" rx="2" fill="white" fillOpacity="0.4" />

                {/* Star Icon (Reward) */}
                <path
                    d="M75 40L77.4 44.8L82.7 45.6L78.8 49.3L79.7 54.6L75 52.1L70.3 54.6L71.2 49.3L67.3 45.6L72.6 44.8L75 40Z"
                    fill="white"
                />

                {/* Highlight Overlay */}
                <rect
                    x="10"
                    y="25"
                    width="80"
                    height="27"
                    rx="12"
                    fill="white"
                    fillOpacity="0.1"
                />
            </svg>
        </div>
    );
};

export default Logo;
